import axios from "axios";

const option: {
    baseURL: string,
    headers?: any
} = {
    baseURL: process.env.REACT_APP_BASE_URL ?? 'http://localhost:5001/api/',
}

if (localStorage.getItem(process.env.REACT_APP_TOKEN_NAME ?? 'token')) {
    option.headers = {
        authorization: `Bearer ${localStorage.getItem(process.env.REACT_APP_TOKEN_NAME ?? 'token')}`
    }
}

const http = axios.create(option);

export default http;